import { Grid } from '@material-ui/core';
import React from 'react';
import { ItemTypes } from 'src/common/enumerations/rti-enums/item-types';
import { ReactComponent as TareLink } from '../../common/media/link.svg';
import { styles } from './action-window-styles';

const ActionWindowLinkedLine: React.FC<Props> = (props: Props): JSX.Element => {
  const {
    linkedItemWeightText,
    linkedLineText,
    linkedLinePrice,
    linkedLineUnitPrice,
    baseQuantifier,
    atomicMsuUnit,
    linkedItemType,
  } = props;
  const classes = styles({});

  return (
    <>
      <Grid container className={`fullWidth ${classes.ItemDescriptionPadding}`}>
        <Grid item className={classes.linkedLineContainer}>
          <Grid item className={classes.linkedLineIcon}>
            <TareLink className={classes.icon} />
          </Grid>
          <Grid
            container
            className={`${classes.linkedLine} ${classes.superText}`}
            justifyContent='space-between'
          >
            <Grid item data-testid='action-window-linked-item-text' className={classes.alignCenter}>
              {linkedItemType === ItemTypes.Tare && !linkedLinePrice && (
                <span
                  className={classes.lineItem}
                  data-testid='action-window-linked-item-weight-text'
                >
                  {linkedItemWeightText}
                </span>
              )}
              <span className={classes.lineItem}>{linkedLineText}</span>
            </Grid>
            {!linkedLinePrice && linkedItemWeightText && (
              <Grid item className={classes.autoLeftMargin}>
                {' '}
                <span
                  className={`${classes.lineItem} ${classes.linkedLinePrice}`}
                  data-testid='action-window-linked-item-unit-price'
                >
                  {linkedLinePrice}
                </span>
              </Grid>
            )}
            {!linkedItemWeightText && linkedLinePrice && (
              <Grid item className={classes.autoLeftMargin}>
                {' '}
                <span
                  className={classes.lineItem}
                  data-testid='action-window-linked-item-unit-price'
                >
                  {linkedLinePrice}
                </span>
              </Grid>
            )}
          </Grid>
        </Grid>
        <Grid
          container
          className={`fullWidth ${classes.linkedDescriptionContainer}`}
          justifyContent='space-between'
        >
          {linkedItemWeightText && linkedLinePrice && (
            <Grid
              container
              className={classes.itemLineBottomMargin}
              data-testid='quantity-line-container'
            >
              <Grid item className={classes.alignCenter}>
                <span className={classes.lineItem}>(</span>
                <span
                  className={classes.lineItem}
                  data-testid='action-window-linked-item-weight-text'
                >
                  {linkedItemWeightText}
                </span>
                {baseQuantifier ?? (
                  <span
                    className={classes.lineItem}
                    data-testid='action-window-linked-line-quantifier-text'
                  >
                    {baseQuantifier}
                  </span>
                )}
                <span className={classes.lineItem}>{` x ${linkedLineUnitPrice} `}</span>
                <span className={classes.UOMText} data-testid='action-window-linked-line-unit-text'>
                  / {atomicMsuUnit}
                </span>
                <span className={classes.lineItem}>)</span>
              </Grid>
              <Grid item className={classes.autoLeftMargin}>
                {' '}
                <span
                  className={`${classes.lineItem} ${classes.linkedLinePrice}`}
                  data-testid='action-window-linked-item-unit-price'
                >
                  {linkedLinePrice}
                </span>
              </Grid>
            </Grid>
          )}
        </Grid>
      </Grid>
    </>
  );
};

interface Props {
  linkedItemWeightText?: string;
  linkedLineText?: string;
  linkedLinePrice?: string;
  linkedLineUnitPrice?: string;
  baseQuantifier?: string;
  atomicMsuUnit?: string;
  linkedItemType?: string;
}

export default ActionWindowLinkedLine;
